<template>
	<div class="container">
		<div class="pc_box">
			<!--内容-->
			<div class="main_box">
				<!--banner-->
				<div class="banner_box">
					<div class="banner_main">
						<div class="left">
							<div>
								<div
									data-aos="fade-right"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
								>
									<div
										v-if="false"
										class="two_box"
										data-aos="fade-right"
										data-aos-duration="400"
										data-aos-delay="400"
										data-aos-offset="0"
										data-aos-once="true"
									>库尔·企业文化</div>
									<div class="one_box">
										<span class="one">Aiiso Truth Code</span>
									</div>
								</div>
								<div
									v-if="false"
									class="three_box"
									data-aos="fade-right"
									data-aos-duration="400"
									data-aos-delay="700"
									data-aos-offset="0"
									data-aos-once="true"
								>@21&nbsp;&nbsp;意指&nbsp;&nbsp;甭管三七二十一&nbsp;&nbsp;撸起袖子加油干</div>
							</div>
						</div>
						<div class="right animate__animated animate__fadeIn">
							<img src="../../../assets/img_public/about/qywh/banner_img.png" />
						</div>
					</div>
				</div>
				<!--banner-->
				<!--block_1-->
				<div class="main_box_1">
					<!--关联网站-->
					<div class="link_box" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
						<div class="title">Associated Website</div>
						<div class="logo_box">
							<div v-for="(value, index) in linkData" class="logo_top">
								<div v-for="(value2, index2) in value.data" class="logo_top_el">
									<a :href="value2.href" target="_blank">
										<img :class="value2.class" :src="value2.imgUrl" />
									</a>
								</div>
							</div>
						</div>
					</div>
					<!--关联网站-->
					<!--区块1-->
							<div class="main_box_1_block_1">
								<div class="left" data-aos="fade-right" data-aos-duration="400" data-aos-once="true">
									<div class="txt_box">
										<div class="tit">Natural Science Principles</div>
										<van-divider
										  :style="{ borderColor: '#071A21', padding: '0', margin: '10px 0 40px 0', width: '0px' }"
										/>
										<div class="txt" style="text-align: left;">Proven & Currently Unverifiable Existences</div>
									</div>
								</div>
								<div class="right" data-aos="fade-left" data-aos-duration="400" data-aos-once="true">
									<img src="../../../assets/img_public/about/qywh/block_bg_1.png" />
								</div>
							</div>
							<!--区块1-->
							<!--区块2-->
							<div class="main_box_1_block_2">
								<div class="left" data-aos="fade-right" data-aos-duration="400" data-aos-once="true">
									<img src="../../../assets/img_public/about/qywh/block_bg_2.png" />
								</div>
								<div class="right" data-aos="fade-left" data-aos-duration="400" data-aos-once="true">
									<div class="txt_box" style="text-align: left;">
										<div class="tit">The Law of Growth</div>
										<div class="txt">1.&nbsp;&nbsp;Enhance Learning to Improve Abilities</div>
										<div class="txt">2.&nbsp;&nbsp;Continuously Implement Execution</div>
										<div class="txt">3.&nbsp;&nbsp;Regularly Identify & Correct Shortcomings</div>
										<div class="txt">4.&nbsp;&nbsp;Be Dedicated & Responsible at Work</div>
										<div class="txt">5.&nbsp;&nbsp;Build a Community of Shared Interests</div>
									</div>
								</div>
							</div>
							<!--区块2-->
						</div>
						<!--block_1-->
						<!--block_2-->
						<div class="main_box_2">
							<!--CU精神-->
							<div class="main_box_2_block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
								<img src="../../../assets/img_public/about/qywh/spirit_pc.webp" />
							</div>
							<!--CU精神-->
							<!--区块2-->
							<div class="main_box_2_block_2">
								<div class="left" data-aos="fade-right" data-aos-duration="400" data-aos-once="true">
									<!-- <div class="icon">.</div> -->
									<div class="txt_box">
										<div class="tit">Work Requirements@21</div>
										<div class="tit_spec">Always Think While You Work</div>
										<div class="txt">What to do, by Whom;</div>
										<div class="txt">When, Where, & How to Perform Tasks;</div>
										<div class="txt">What Documents, Equipment & Materials Shall beUsed;</div>
										<div class="txt">How to Monitor & Measure these Activities;</div>
										<div class="txt">Documentation Required by Stakeholders.</div>
									</div>
								</div>
								<div class="right" data-aos="fade-left" data-aos-duration="400" data-aos-once="true">
									<img src="../../../assets/img_public/about/qywh/block_bg_3.webp" />
								</div>
							</div>
							<!--区块2-->
							<!--区块3-->
							<div class="main_box_2_block_3">
								<div class="left" data-aos="fade-right" data-aos-duration="400" data-aos-once="true">
									<img src="../../../assets/img_public/about/qywh/block_bg_4_1.png" />
								</div>
								<div class="right" data-aos="fade-left" data-aos-duration="400" data-aos-once="true">
									<!-- <div class="icon">.</div> -->
									<div class="txt_box" style="text-align: left;">
										<div class="tit">Two Learning & One Action</div>
										<div class="txt">Learn Cultural Regulations</div>
										<div class="txt">Learn Professional Skills</div>
										<div class="txt">Be A Qualified Colleague</div>
									</div>
								</div>
							</div>
							<!--区块3-->
						</div>
						<!--block_2-->
						<!--block_3-->
						<div class="main_box_3" style="padding-bottom: 0;">
							<div class="main_box_3_block_1" data-aos="zoom-in-up" data-aos-duration="400" data-aos-once="true">
								<div class="txt_box_el">
									<div class="tit">Working Principles</div>
									<div class="diver"></div>
									<div class="txt">Follow the Rules</div>
									<div class="txt">Proceed Step by Step</div>
									<div class="txt">Focus on Details,</div>
									<div class="txt">Then Fuel Innovation</div>
								</div>
								<div class="txt_box_el txt_h">
									<div class="tit">Decision Making Procedures</div>
									<div class="diver"></div>
									<div class="txt" style="padding-bottom: 17.5px;">Democratic Decision Making (Roughly Three Talk)</div>
									<div class="txt" style="padding-bottom: 17.5px;">Authoritative Management (Chief System)</div>
									<div class="txt">Major Decisions Confirmation (President's Office)</div>
								</div>
							</div>
						</div>
						<div class="main_box_3">
							<div class="main_box_3_block_1" data-aos="zoom-in-up" data-aos-duration="400" data-aos-once="true">
								<div class="txt_box_el">
									<div class="tit">Production Guidelines</div>
									<div class="diver"></div>
									<div class="txt">Follow Operating Standards</div>
									<div class="txt">Meet Quality Standards</div>
									<div class="txt">Maintain Appropriate Speed</div>
									<div class="txt">Observe Discipline & Punctuality</div>
								</div>
								<div class="txt_box_el txt_h">
									<div class="tit">The Four Rules for Joy</div>
									<div class="diver"></div>
									<div class="txt" style="padding-bottom: 0px;">Be Respectful to Superiors</div>
									<div class="txt" style="padding-bottom: 0px;">Be Kind to Juniors</div>
									<div class="txt" style="padding-bottom: 0px;">Be Harmonious with People</div>
									<div class="txt">Be True in Handing Affairs</div>
								</div>
							</div>
						</div>
						<!--block3-->
						<!--block4-->
						<div class="main_box_4">
							<!--区块1-->
							<div class="main_box_4_block_1">
								<div class="left" data-aos="fade-right" data-aos-duration="400" data-aos-once="true">
									<div class="txt_box">
										<div class="tit" style="text-align: left;">Business Policy</div>
										<div class="txt">
											&ensp;<span><img src="../../../assets/img_public/about/qywh/icon_1.png" /></span>
											Perfect Quality
										</div>
										<div class="txt">
											&ensp;<span><img src="../../../assets/img_public/about/qywh/icon_2.png" /></span>
											Sincere Service
										</div>
										<div class="txt">
											&ensp;<span><img src="../../../assets/img_public/about/qywh/icon_3.png" /></span>
											Standardized Management
										</div>
										<div class="txt">
											&ensp;<span><img src="../../../assets/img_public/about/qywh/icon_4.png" /></span>
											Pioneering & Innovation
										</div>
									</div>
								</div>
								<div class="right" data-aos="fade-left" data-aos-duration="400" data-aos-once="true">
									<img src="../../../assets/img_public/about/qywh/block_bg_5.webp" />
								</div>
							</div>
							<!--区块1-->
							<!--区块2-->
							<div class="main_box_4_block_2" data-aos="zoom-in-down" data-aos-duration="400" data-aos-once="true">
								<div class="txt_box_el">
									<div class="tit">CU Belief</div>
									<div class="diver"></div>
									<div class="txt">Gifts Create Values</div>
								</div>
								<div class="txt_box_el">
									<div class="tit">CU Purpose</div>
									<div class="diver"></div>
									<div class="txt">Safety Effectiveness Commitment</div>
								</div>
								<div class="txt_box_el">
									<div class="tit">CU Slogan</div>
									<div class="diver"></div>
									<div class="txt">Aspire to Soar High, yet Stay Grounded in Action.</div>
								</div>
							</div>
							<!--区块2-->
							<!--区块3-->
							<div class="main_box_4_block_3">
								<div class="left" data-aos="fade-right" data-aos-duration="400" data-aos-once="true">
									<img class="bg" src="../../../assets/img_public/about/qywh/block_bg_6_1.png" />
									<img class="float" src="../../../assets/img_public/about/qywh/block_bg_6_1_1.png" />
								</div>
								<div class="right" data-aos="fade-left" data-aos-duration="400" data-aos-once="true">
									<div class="txt_box">
										<div class="top_box">
											<!-- <div class="icon">.</div> -->
											<div class="main">
												<div class="tit">CU Vision</div>
												<div class="txt">
													From Organic to Restful, Full Supply Chain Services @ 2.1 Billion People
												</div>
											</div>
										</div>
										<div class="bottom_box">
											<!-- <div class="icon">.</div> -->
											<div class="main">
												<div class="tit">CU Talent</div>
												<div class="txt">We are Family, Embrace & Replace</div>
												<div class="txt">Welcome A-players, Let Go of B-behaviors</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!--区块3-->
						</div>
						<!--block4-->
						<!--block5-->
						<div class="main_box_5">
							<!--区块1-->
							<div class="main_box_5_block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
								<div class="tit">CU Normalization</div>
								<div class="txt_box">
									<div class="txt">Normalize the True Mentorship</div>
									<div class="txt">Normalize the Reward System</div>
									<div class="txt">Normalize Monitoring Delict</div>
								</div>
								<!-- <div class="tips">蟑蝇之类：</div>
								<div class="tips">“ 蟑 ” 泛指 存在盗用物资、吃里扒外、讹诈钱财等行为</div>
								<div class="tips">“ 蝇 ” 泛指 具有消极怠工、散布反派言论等负能量</div> -->
							</div>
							<!--区块1-->
						</div>
						<!--block5-->
						<!--block6-->
						<div class="main_box_6">
							<!--区块1-->
							<div class="main_box_6_block_1">
								<div class="left" data-aos="fade-right" data-aos-duration="400" data-aos-once="true">
									<div class="txt_box">
										<div class="tit">CU "The Two Don't "</div>
										<div class="tit_spec">&ensp;&ensp;Mess Around</div>
										<div class="txt">1.1&nbsp;Have standards, but not following the standards,</div>
										<div class="txt">1.2&nbsp;Work blindly when there is no standard,</div>
										<div class="txt">1.3&nbsp;Do without questioning when you know there is something wrong with thestandard;</div>
										<div class="txt"></div>
										<div class="tit_spec">&ensp;&ensp;Talk Nonsense</div>
										<div class="txt">2.1&nbsp;Jump to conclusions without investigation or research,</div>
										<div class="txt">2.2&nbsp;Overconfidence it will work without trying it,</div>
										<div class="txt">2.3&nbsp;Believe it will always be the case with one single proof.</div>
									</div>
								</div>
								<div class="right" data-aos="fade-left" data-aos-duration="400" data-aos-once="true">
									<img src="../../../assets/img_public/about/qywh/block_bg_7.png" />
								</div>
							</div>
							<!--区块1-->
							<!--区块2-->
							<!-- <div class="main_box_6_block_2" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
								<div class="left">当前任务</div>
								<div class="right">为全球提供&nbsp;准确&nbsp;实惠&nbsp;易用&nbsp;的诊断产品<br />一起改变全球诊断</div>
							</div> -->
							<!--区块2-->
							<!--区块3-->
							<div class="main_box_6_block_3">
								<div class="left" data-aos="fade-right" data-aos-duration="400" data-aos-once="true">
									<img src="../../../assets/img_public/about/qywh/block_bg_8.png" />
								</div>
								<div class="right" data-aos="fade-left" data-aos-duration="400" data-aos-once="true">
									<div class="txt_box">
										<div class="tit_box">
											<div class="tit">Current Mission</div>
											<div class="txt">Provide Affordable, Use-friendly & Precision Diagnostic Products for theWorld</div>
											<div class="txt">Change Global Diagnostics Together</div>
										</div>
										<div class="top_box">
											<!-- <div class="icon">.</div> -->
											<div class="main">
												<div class="txt">
													<span>Life</span>
													It's hard to balance loyalty & filial piety, choose the golden mean.
												</div>
											</div>
										</div>
										<div class="bottom_box">
											<!-- <div class="icon">.</div> -->
											<div class="main">
												<div class="txt">
													<span>Human Nature</span>
													People tend to care about themselves first.
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!--区块3-->
						</div>
						<!--block6-->
						<!--block7-->
						<div class="main_box_7">
							<div class="main_box_7_block_1" data-aos="zoom-in" data-aos-duration="400" data-aos-once="true">
								<div class="tit">This World</div>
								<div class="txt">Everything is in Flux, Keeping Pace with the Times.</div>
								<div class="bg_box">
									<!-- <img src="../../../assets/img_public/about/qywh/icon_earth.png" /> -->
									<video 
										src="https://culture.baoyitong.com.cn/world_en.mp4?t=20250102"
										autoplay
										loop
										muted
									></video>
								</div>
							</div>
						</div>
						<!--block7-->
					</div>
					<!--内容-->
					<!--分割线-->
					<!-- <van-divider :style="{padding: '0', margin: '0', borderColor: '#0B318F',}" /> -->
					<!--分割线-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import $ from 'jquery'
export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,  //界面loading
			linkData: [
				{data: [
					{imgUrl: require('@/assets/img_public/about/qywh/link_7.png'), href: 'https://cordx.com/', class: 'link_img_7'},
					{imgUrl: require('@/assets/img_public/about/qywh/bonore.png'), href: 'https://bonore.com/', class: 'link_img_3'},
					{imgUrl: require('@/assets/img_public/about/qywh/coretests.png'), href: 'https://coretests.com/', class: 'link_img_2'},
					{imgUrl: require('@/assets/img_public/about/qywh/link_4.png'), href: 'https://cupet.com', class: 'link_img_5'},
				]},
				{data: [
					{imgUrl: require('@/assets/img_public/about/qywh/ucreagent.png'), href: 'https://ucreagent.com/', class: 'link_img_4'},
					{imgUrl: require('@/assets/img_public/about/qywh/link_6.png'), href: 'https://i-membrane.com/', class: 'link_img_6'},
				],}
			],
		}
	},
	created(){
		let that = this;
		if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
			that.$router.replace({path: '/cultureh5'});
		}
	},
	mounted() {
		let that = this;
		that.$nextTick(() => {
			that.isLoading = false;
		});
		//库尔精神动画
		$('.main_box_2 li').mouseenter(function(){
			$(this).stop().animate({
				width: 320 ,
			},400).addClass('actived').find('.small').stop().fadeOut().siblings('.big').stop().fadeIn().css({'display': 'block'});
			$(this).siblings('li').stop().animate({
				width: 172,
			},400).removeClass('actived').find('.small').stop().fadeIn().siblings('.big').stop().fadeOut();
		});
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
.pc_box{
	min-width: 1264px;
}
/*区域7*/
.main_box_7{
	position: relative;
	.main_box_7_block_1{
		width: 1200px;
		height: 900px;
		margin: 0 auto;
		overflow: hidden;
		position: relative;
		text-align: center;
		.tit{
			padding-bottom: 30px;
			font-size: 44px;
			color: #071A21;
			font-weight: bold;
		}
		.txt{
			padding-bottom: 50px;
			font-size: 24px;
			color: #071A21;
		}
		.bg_box{
			max-width: 1200px;
			position: absolute;
			bottom: -600px;
			video{
				width: 1200px;
				background-color: transparent;
				object-fit: contain;
				outline: none !important;
				// 注意：IE和Edge浏览器不支持mix-blend-mode属性
				mix-blend-mode: darken;
			}
			video:focus {
				outline:none !important;
			}
		}
	}
	.bot_box{
		width: 100%;
		position: absolute;
		bottom: -2px;
		z-index: 1;
		img{
			width: 100%;
			height: 100%;
			vertical-align:top;
		}
	}
}
@-webkit-keyframes rotation {
	0%{-webkit-transform:rotate(0deg);}
	50%{-webkit-transform:rotate(180deg);}
	100%{-webkit-transform:rotate(360deg);}
}

/*区域6*/
.main_box_6{
	padding-bottom: 140px;
	.main_box_6_block_3{  /*块3*/
		width: 1264px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		padding-top: 80px;
		.right{
			flex: 1;
			display: flex;
			align-items: center;
			position: relative;
			padding: 0 0 0 40px;
			.tit_box{
				
			}
			.txt_box{
				.tit_box{
					padding-bottom: 40px;
					.tit{
						padding-bottom: 20px;
						font-size: 36px;
						font-weight: bold;
						color: #071A21;
					}
					.txt{
						font-size: 24px;
						color: #071A21;
					}
				}
				.top_box{
					padding-bottom: 35px;
				}
				.top_box, .bottom_box{
					display: flex;
					line-height: 1;
					.icon{
						position: relative;
						top: -35px;
						padding-right: 25px;
						font-size: 70px;
						font-weight: bold;
					}
					.main{
						.tit{padding-bottom: 20px;font-size:44px;color: #071A21;font-weight: bold;}
						.txt{font-size: 24px;color: #071A21;line-height: 40px;
							font-weight: bold;
							span{
								// font-size: 32px;
								display: inline-block;
								border-right: 3px solid #071A21;
								color: #071A21;
								padding-right: 20px;
								margin-right: 12px;
								height: 26px;
								line-height: 1.3;
							}
						}
					}
				}
			}
		}
		.left{
			width: auto;
			overflow: hidden;
			border-radius: 0 195px 195px 0 e("/") 0 195px 195px 0;
			img{
				width: 556px;
				transition: all 0.6s;
				cursor: pointer;
			}
			img:hover{
				transform: scale(1.3);
			}
		}
	}
	.main_box_6_block_1{  /*块1*/
		width: 1264px;
		margin: 0 auto;
		padding-top: 100px;
		display: flex;
		align-items: center;
		.left{
			flex: 1;
			display: flex;
			align-items: center;
			position: relative;
			// justify-content: right;
			// padding-left: 40px;
			.txt_box{
				.tit{font-size:44px;color: #071A21;font-weight: bold;}
				.tit_spec{padding: 20px 0 10px 0;font-size:24px;color: #071A21;font-weight: bold;}
				.txt{font-size: 24px;color: #071A21;line-height: 36px;text-indent: 34px;padding: 0 10px 0 20px;}
			}
		}
		.right{
			width: auto;
			overflow: hidden;
			border-radius: 195px 0 0 195px e("/")195px 0 0 195px;
			height: 308px;
			img{
				width: 485px;
				transition: all 0.6s;
				cursor: pointer;
			}
			img:hover{
				transform: scale(1.3);
			}
		}
	}
}
/*区域5*/
.main_box_5{
	background-color: #F4EDE4;
	padding: 96px 0;
	.main_box_5_block_1{  /*块1*/
		width: 1264px;
		margin: 0 auto;
		text-align: center;
		.tit{
			font-size: 54px;
			font-weight: bold;
			padding: 0 15px 14px 15px;
			display: inline-block;
			// border-bottom: 1px solid #541554;
		}
		.txt_box{
			padding: 36px 0 40px 0;
			display: flex;
			.txt{
				flex: 1;
				text-align: center;
				font-size: 30px;
				font-weight: bold;
			}
		}
		.tips{
			font-size: 24px;
			color: #999999;
			line-height: 42px;
		}
	}
}
/*区域4*/
.main_box_4{
	padding-bottom: 100px;
	.main_box_4_block_3{  /*块3*/
		width: 1264px;
		margin: 0 auto;
		display: flex;
		padding-top: 20px;
		.left{width: auto;
			border-radius: 0 135px 135px 0;
			overflow: hidden;
			width: 556px;
			height: 460px;
			border: 1px solid #ffffff;
			position: relative;
			img.bg{
				position: relative;
				top: 178px;
			}
			img.float{
				position: absolute;
				top: 120px;
				left: 0;
				cursor: pointer;
				transition: all 0.6s;
			}
			img.float:hover{
				transform: translateY(-60px);
			}
		}
		.right{
			flex: 1;
			display: flex;
			align-items: center;
			position: relative;
			padding: 120px 0 0 120px;
			.txt_box{
				.top_box{
					padding-bottom: 40px;
				}
				.top_box, .bottom_box{
					display: flex;
					.icon{
						position: relative;
						top: -35px;
						padding-right: 40px;
						font-size: 70px;
						font-weight: bold;
					}
					.main{
						.tit{padding-bottom: 20px;font-size:44px;color: #071A21;font-weight: bold;}
						.txt{font-size: 24px;color: #071A21;line-height: 40px;}
					}
				}
			}
		}
	}
	.main_box_4_block_2{  /*块2*/
		width: 1264px;
		margin: 0 auto;
		display: flex;
		padding-top: 85px;
		.txt_box_el{
			flex: 1;
			margin-right: 20px;
			// border: 1px solid #541554;
			border-radius: 20px;
			padding: 58px 0;
			text-align: center;
			background-color: #F7F6F9;
			.diver{
				width: 30px;
				height: 4px;
				background-color: #A50073;
				border-radius: 4px;
				margin: 0px auto 20px auto;
			}
			.tit{
				color: #000000;
				font-size: 48px;
				padding-bottom: 10px;
			}
			.txt{
				font-size: 24px;
				color: #071A21;
			}
		}
		.txt_box_el:last-child{
			margin-right: 0;
		}
	}
	.main_box_4_block_1{  /*区块1*/
		width: 1264px;
		margin: 0 auto;
		display: flex;
		padding-top: 100px;
		.right{
			width: auto;
			display: inherit;
			overflow: hidden;
			border-radius: 195px 0 0 195px e("/") 195px 0 0 195px;
			img{
				width: 556px;
				cursor: pointer;
				transition: all 0.6s;
			}
			img:hover{
				transform: scale(1.3);
			}
		}
		.left{
			flex: 1;
			display: flex;
			align-items: center;
			position: relative;
			justify-content: center;
			.txt_box{
				text-align: center;
				.tit{padding-bottom: 30px;font-size:44px;color: #071A21;font-weight: bold;}
				.tit_spec{padding-top: 40px;font-size:24px;color: #541554;font-weight: bold;}
				.txt{
					font-size: 24px;
					color: #071A21;
					line-height: 1;
					text-align: left;
					padding-bottom: 20px;
					position: relative;
					left: -5px;
					span{
						width: 40px;
						height: 40px;
						line-height: 40px;
						display: inline-block;
						background-color: #F7F6F9;
						text-align: center;
						margin-right: 15px;
						border-radius: 50%;
						img{
							width: 18px;
							position: relative;
							top: 10px;
						}
					}
				}
				.txt:last-child{
					padding-bottom: 0;
				}
			}
		}
	}
}
/*区域3*/
.main_box_3{
	padding: 87px 0;
	background-color: #F4EDE4;
	.main_box_3_block_1{
		width: 1264px;
		margin: 0 auto;
		display: flex;
		.txt_box_el{
			flex: 1;
			text-align: center;
			color: #333333;
			.diver{
				width: 30px;
				height: 4px;
				background-color: #A50073;
				margin: 0 auto;
				margin-bottom: 24px;
				border-radius: 4px;
			}
			.tit{
				display: inline-block;
				padding-bottom: 18px;
				font-size: 34px;
				font-weight: bold;
				// border-bottom: 1px solid #333333;
			}
			.txt{
				font-size: 24px;
				line-height: 36px;
			}
		}
		.txt_h{
			.txt{
				// line-height: 50px;
			}
		}
	}
}
/*区域2*/
.main_box_2{
	padding-bottom: 100px;
	.main_box_2_block_3{
		display: flex;
		width: 1264px;
		margin: 0 auto;
		padding-top: 80px;
		.left{
			width: auto;
			display: inherit;
			border-radius: 0 195px 195px 0 e("/") 0 195px 195px 0;
			overflow: hidden;
			width: 556px;
			img{
				position: relative;
				left: -60px;
				transition: all 0.6s;
				cursor: pointer;
			}
			img:hover{
				transform: translateX(60px);
			}
		}
		.right{
			flex: 1;
			display: flex;
			align-items: center;
			position: relative;
			justify-content: center;
			text-align: center;
			.icon{
				position: relative;
				top: -90px;
				padding-right: 40px;
				font-size: 70px;
				font-weight: bold;
			}
			.txt_box{
				.tit{padding-bottom: 20px;font-size:44px;color: #071A21;font-weight: bold;}
				.txt{font-size: 24px;color: #071A21;line-height: 40px;}
			}
		}
	}
	.main_box_2_block_2{  /*块2*/
		display: flex;
		width: 1264px;
		margin: 0 auto;
		padding-top: 76px;
		.right{
			width: auto;
			display: inherit;
			border-radius: 195px 0 0 195px e("/") 195px 0 0 195px;
			overflow: hidden;
			width: 556px;
			img{
				transition: all 0.6s;
				cursor: pointer;
			}
			img:hover{
				transform: translateX(-60px);
			}
		}
		.left{
			flex: 1;
			display: flex;
			align-items: center;
			position: relative;
			padding-left: 75px;
			.icon{
				position: absolute;
				top: -38px;
				font-size: 70px;
				font-weight: bold;
			}
			.txt_box{
				// padding-left: 55px;
				.tit{font-size:44px;color: #071A21;font-weight: bold;}
				.tit_spec{padding: 15px 0;font-size:24px;color: #071A21;font-weight: bold;
					span{
						color: #DC000C;
						font-size: 30px;
						font-weight: normal;
					}
				}
				.txt{font-size: 24px;color: #071A21;line-height: 40px;}
			}
		}
	}
	.main_box_2_block_1{  /*库尔精神-块1*/
		width: 100%;
		margin: 0 auto;
		padding-top: 0px;
		img{
			width: 100%;
		}
	}
}
/*区域1*/
.main_box_1{
	padding-bottom: 100px;
	background-color: #F4EDE4;
	.main_box_1_block_2{  /*块2*/
		display: flex;
		width: 1264px;
		margin: 0 auto;
		padding-top: 80px;
		.right{
			flex: 1;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			.tit{padding-bottom: 20px;font-size:48px;color: #071A21;font-weight: bold;}
			.txt{font-size: 24px;color: #071A21;line-height: 40px;}
		}
		.left{
			width: auto;
			img{
				width: 556px;
				cursor: pointer;
				transition: all 0.6s;
			}
			img:hover{
				transform: translateX(60px);
			}
		}
	}
	.main_box_1_block_1{  /*块1*/
		display: flex;
		width: 1264px;
		margin: 0 auto;
		padding-top: 100px;
		.left{
			flex: 1;
			display: flex;
			align-items: center;
			padding-left: 60px;
			text-align: center;
			.tit{font-size: 50px;color: #071A21;font-weight: bold;}
			.txt{font-size: 21px;color: #071A21;}
		}
		.right{
			width: auto;
			img{
				width: 556px;
				cursor: pointer;
				transition: all 0.6s;
			}
			img:hover{
				transform: translateX(-60px);
			}
		}
	}
	.link_box{  /*关联网站*/
		width: 1264px;
		margin: 0 auto;
		.title{ padding: 46px 0 7px 0; font-size: 46px; color: #071A21; text-align: center;}
		.logo_box{
			position: relative;
			left: -20px;
			padding: 0 20px 0 30px;
		}
		.logo_box .logo_top{
			display: flex;
			padding-top: 23px;
			.logo_top_el{
				flex: 1;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				.link_img_1{width: 180px;}
				.link_img_2{width: 150px;position: relative;left: 30px;}
				.link_img_3{width: 180px;}
				.link_img_4{height: 50px;position: relative;left: 100px;}
				.link_img_5{width: 130px;}
				.link_img_6{width: 190px;position: relative;left: -100px;top: 6px;}
				.link_img_7{width: 150px;}
			}
		}
	}
}

/*banner*/
.banner_box{
	//height: 760px;
	display: flex;
	justify-content: center;
	background-color: #541554;
	.banner_main{
		width: 1264px;
		padding-top: 40px;
		//margin-top: 97px;
		display: flex;
		.left{
			width: auto;
			display: flex;
			align-items: center;
			word-break: keep-all;
			.one_box{
				word-break: keep-all;
				.one{
					color: #ffffff;
					font-size: 64px;
					font-weight: bold;
				}
				.two{
					color: #ECB22E;
					font-size: 64px;
					font-weight: bold;
				}
			}
			.two_box{
				padding-bottom: 10px;
				color: #ffffff;
				font-size: 34px;
				word-break: keep-all;
			}
			.three_box{
				padding-top: 10px;
				color: #ffffff;
				font-size: 22px;
				word-break: keep-all;
			}
		}
		.right{
			flex: 1;
			display: flex;
			justify-content: center;
		}
	}
}
</style>
